const solutions = {
  'infogerance-cyber': {
    icon: 'Shield',
    image: 'https://images.unsplash.com/photo-1614064642261-3ccbfafa481b?w=1200',
    promise: {
      fr: 'Votre informatique supervisée, sécurisée, 24h/24.',
      en: 'Your IT supervised, secured, 24/7.',
    },
    benefits: [
      { fr: 'Supervision proactive de votre infrastructure', en: 'Proactive monitoring of your infrastructure' },
      { fr: 'Protection contre les cybermenaces (phishing, ransomware)', en: 'Protection against cyber threats (phishing, ransomware)' },
      { fr: 'Mises à jour et correctifs automatisés', en: 'Automated updates and patches' },
      { fr: 'Support utilisateur réactif', en: 'Responsive user support' },
      { fr: 'Plan de reprise d\'activité (PRA) testé', en: 'Tested disaster recovery plan (DRP)' },
      { fr: 'Rapports mensuels de sécurité', en: 'Monthly security reports' },
    ],
    useCases: [
      {
        situation: { fr: 'Un cabinet d\'avocats de 15 personnes subissait des pannes récurrentes.', en: 'A 15-person law firm was experiencing recurring outages.' },
        action: { fr: 'Audit complet, migration cloud hybride, mise en place du monitoring.', en: 'Complete audit, hybrid cloud migration, monitoring setup.' },
        result: { fr: 'Zéro panne depuis 18 mois, satisfaction utilisateurs en hausse de 40%.', en: 'Zero downtime for 18 months, user satisfaction up 40%.' },
      },
      {
        situation: { fr: 'Une PME industrielle victime d\'un ransomware sans sauvegarde fiable.', en: 'An industrial SME hit by ransomware without reliable backup.' },
        action: { fr: 'Restauration d\'urgence, déploiement d\'une stratégie de sauvegarde 3-2-1 et EDR.', en: 'Emergency restoration, deployment of 3-2-1 backup strategy and EDR.' },
        result: { fr: 'Reprise en 4h, aucun rançongiciel détecté depuis la mise en place.', en: 'Recovery in 4h, no ransomware detected since implementation.' },
      },
      {
        situation: { fr: 'Un groupe médical devait se conformer aux exigences HDS.', en: 'A medical group needed to comply with HDS requirements.' },
        action: { fr: 'Audit de conformité, migration vers un hébergeur HDS, durcissement des accès.', en: 'Compliance audit, migration to HDS host, access hardening.' },
        result: { fr: 'Conformité obtenue, audit externe réussi du premier coup.', en: 'Compliance achieved, external audit passed first time.' },
      },
    ],
    cta: { fr: 'Demander un devis cybersécurité gratuit', en: 'Request a free cybersecurity quote' },
    proofPartners: ['Microsoft', 'ESET', 'Acronis', 'Veeam', 'Eaton'],
    externalLink: 'https://cyber.meteris.fr',
    externalLabel: { fr: 'Découvrir notre offre Cyber', en: 'Discover our Cyber offer' },
  },
  'telephonie': {
    icon: 'Phone',
    image: 'https://images.unsplash.com/photo-1598978642354-11ba53ba56fb?w=1200',
    promise: {
      fr: 'Une téléphonie moderne qui vous fait économiser.',
      en: 'Modern telephony that saves you money.',
    },
    benefits: [
      { fr: 'Économies de 30 à 50% sur votre facture télécom', en: '30-50% savings on your telecom bill' },
      { fr: 'Visioconférence intégrée, sans outil supplémentaire', en: 'Integrated video conferencing, no additional tool needed' },
      { fr: 'Mobilité totale : bureau, domicile, déplacement', en: 'Total mobility: office, home, on the go' },
      { fr: 'Standard automatique et messagerie unifiée', en: 'Auto-attendant and unified messaging' },
      { fr: 'Installation et migration sans coupure', en: 'Installation and migration with zero downtime' },
    ],
    useCases: [
      {
        situation: { fr: 'Un réseau d\'agences immobilières avec 8 sites et un standard obsolète.', en: 'A real estate agency network with 8 sites and an obsolete PBX.' },
        action: { fr: 'Migration vers Yeastar P-Series Cloud, interconnexion des sites.', en: 'Migration to Yeastar P-Series Cloud, site interconnection.' },
        result: { fr: 'Facture divisée par 2, appels inter-sites gratuits, satisfaction clients améliorée.', en: 'Bill cut in half, free inter-site calls, improved customer satisfaction.' },
      },
      {
        situation: { fr: 'Une société de conseil avec 50% de télétravail.', en: 'A consulting firm with 50% remote work.' },
        action: { fr: 'Déploiement de Linkus UC, softphone sur PC et mobile.', en: 'Linkus UC deployment, softphone on PC and mobile.' },
        result: { fr: 'Collaborateurs joignables partout, zéro appel manqué.', en: 'Employees reachable everywhere, zero missed calls.' },
      },
      {
        situation: { fr: 'Un centre d\'appels PME cherchant à améliorer son suivi client.', en: 'An SME call center looking to improve client follow-up.' },
        action: { fr: 'Mise en place du wallboard, files d\'attente intelligentes, CRM intégré.', en: 'Wallboard setup, intelligent queuing, CRM integration.' },
        result: { fr: 'Temps d\'attente réduit de 60%, taux de résolution au premier appel +25%.', en: 'Wait time reduced by 60%, first-call resolution +25%.' },
      },
    ],
    cta: { fr: 'Évaluer mes besoins téléphonie', en: 'Evaluate my telephony needs' },
    proofPartners: ['Yeastar Gold Partner'],
    externalLink: 'https://yeastar.meteris.fr',
    externalLabel: { fr: 'Découvrir nos solutions Yeastar', en: 'Discover our Yeastar solutions' },
  },
  'copieurs': {
    icon: 'Printer',
    image: 'https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?w=1200',
    promise: {
      fr: 'Imprimez sereinement, on gère tout le reste.',
      en: 'Print with peace of mind, we handle everything else.',
    },
    benefits: [
      { fr: 'Gestion complète de votre parc multi-marques', en: 'Complete multi-brand fleet management' },
      { fr: 'Maintenance préventive et curative incluse', en: 'Preventive and corrective maintenance included' },
      { fr: 'Consommables livrés automatiquement', en: 'Consumables delivered automatically' },
      { fr: 'Une seule facture, des coûts prévisibles', en: 'One single bill, predictable costs' },
      { fr: 'Audit gratuit de vos coûts d\'impression', en: 'Free audit of your printing costs' },
    ],
    useCases: [
      {
        situation: { fr: 'Un cabinet comptable avec 12 imprimantes de marques différentes et des pannes fréquentes.', en: 'An accounting firm with 12 different-brand printers and frequent breakdowns.' },
        action: { fr: 'Audit, rationalisation du parc, déploiement de 4 multifonctions centralisées.', en: 'Audit, fleet rationalization, deployment of 4 centralized multifunction devices.' },
        result: { fr: 'Coûts réduits de 35%, zéro panne en 12 mois.', en: 'Costs reduced by 35%, zero breakdowns in 12 months.' },
      },
      {
        situation: { fr: 'Une association avec un budget impression incontrôlé.', en: 'An association with uncontrolled printing budget.' },
        action: { fr: 'Mise en place du suivi volumétrique, quotas par service, impression sécurisée.', en: 'Volume tracking, per-department quotas, secure printing setup.' },
        result: { fr: 'Budget impression réduit de 45%, gaspillage quasi éliminé.', en: 'Print budget reduced by 45%, waste nearly eliminated.' },
      },
      {
        situation: { fr: 'Un groupe scolaire cherchant un interlocuteur unique pour ses copieurs.', en: 'A school group seeking a single point of contact for its copiers.' },
        action: { fr: 'Contrat de service global, intervention J+1, gestion des consommables.', en: 'Global service contract, next-day intervention, consumables management.' },
        result: { fr: 'Simplification administrative, disponibilité du parc à 99%.', en: 'Administrative simplification, 99% fleet availability.' },
      },
    ],
    cta: { fr: 'Demander un devis impression gratuit', en: 'Request a free printing quote' },
    proofPartners: ['Multi-marques', 'Konica Minolta', 'Ricoh', 'Canon'],
    externalLink: 'https://mps.meteris.fr',
    externalLabel: { fr: 'Découvrir METERIS MPS', en: 'Discover METERIS MPS' },
  },
  'serveurs-infrastructure': {
    icon: 'Server',
    image: 'https://images.unsplash.com/photo-1691435828932-911a7801adfb?w=1200',
    promise: {
      fr: 'Une infrastructure solide, socle de votre performance.',
      en: 'A solid infrastructure, the foundation of your performance.',
    },
    benefits: [
      { fr: 'Audit et dimensionnement adaptés à vos besoins réels', en: 'Audit and sizing tailored to your real needs' },
      { fr: 'Migration sans interruption de service', en: 'Migration with zero service interruption' },
      { fr: 'Virtualisation, cloud hybride, hyperconvergence', en: 'Virtualization, hybrid cloud, hyperconvergence' },
      { fr: 'Sauvegarde et PRA intégrés', en: 'Integrated backup and disaster recovery' },
      { fr: 'Supervision 24/7 de vos équipements', en: '24/7 equipment monitoring' },
    ],
    useCases: [
      {
        situation: { fr: 'Une PME de 80 postes avec des serveurs de plus de 8 ans.', en: 'An 80-workstation SME with servers over 8 years old.' },
        action: { fr: 'Remplacement par une solution hyperconvergée, migration progressive le week-end.', en: 'Replacement with hyperconverged solution, progressive weekend migration.' },
        result: { fr: 'Performance multipliée par 5, TCO réduit de 30% sur 5 ans.', en: 'Performance multiplied by 5, TCO reduced by 30% over 5 years.' },
      },
      {
        situation: { fr: 'Un site logistique avec une application critique non sauvegardée.', en: 'A logistics site with a critical unsaved application.' },
        action: { fr: 'Mise en place de Veeam, réplication hors site, tests de restauration trimestriels.', en: 'Veeam setup, off-site replication, quarterly restoration tests.' },
        result: { fr: 'RPO de 15 minutes, RTO de 2 heures garanti.', en: '15-minute RPO, guaranteed 2-hour RTO.' },
      },
      {
        situation: { fr: 'Un groupe multi-sites souhaitant centraliser ses données.', en: 'A multi-site group wanting to centralize its data.' },
        action: { fr: 'Architecture cloud hybride Azure + serveur local, synchronisation temps réel.', en: 'Azure hybrid cloud + local server architecture, real-time sync.' },
        result: { fr: 'Accès unifié pour tous les sites, collaboration améliorée de 60%.', en: 'Unified access for all sites, collaboration improved by 60%.' },
      },
    ],
    cta: { fr: 'Demander un devis infrastructure gratuit', en: 'Request a free infrastructure quote' },
    proofPartners: ['Dell', 'Lenovo', 'HP', 'Microsoft Azure', 'Veeam', 'Eaton'],
    externalLink: null,
    externalLabel: null,
  },
  'ia-automatisation': {
    icon: 'Brain',
    image: 'https://images.unsplash.com/photo-1737644467636-6b0053476bb2?w=1200',
    promise: {
      fr: 'L\'IA au service de votre productivité, en toute souveraineté.',
      en: 'AI at the service of your productivity, with full sovereignty.',
    },
    benefits: [
      { fr: 'Systèmes IA souverains, données protégées', en: 'Sovereign AI systems, protected data' },
      { fr: 'Automatisation des tâches répétitives', en: 'Automation of repetitive tasks' },
      { fr: 'Classification et traitement de documents automatisés', en: 'Automated document classification and processing' },
      { fr: 'Assistants IA internes, formés sur vos données', en: 'Internal AI assistants, trained on your data' },
      { fr: 'ROI mesurable dès les premiers mois', en: 'Measurable ROI from the first months' },
    ],
    useCases: [
      {
        situation: { fr: 'Un cabinet RH traitant 500 CV par mois manuellement.', en: 'An HR firm manually processing 500 CVs per month.' },
        action: { fr: 'Déploiement d\'un outil de tri automatique par critères, hébergé en France.', en: 'Deployment of automatic sorting tool by criteria, hosted in France.' },
        result: { fr: 'Temps de présélection réduit de 80%, zéro fuite de données candidats.', en: 'Pre-selection time reduced by 80%, zero candidate data leaks.' },
      },
      {
        situation: { fr: 'Une société de maintenance avec des rapports d\'intervention manuels.', en: 'A maintenance company with manual intervention reports.' },
        action: { fr: 'Automatisation de la rédaction et du classement via IA générative locale.', en: 'Automation of writing and filing via local generative AI.' },
        result: { fr: 'Gain de 3h par technicien et par semaine, rapports standardisés.', en: '3 hours saved per technician per week, standardized reports.' },
      },
      {
        situation: { fr: 'Un e-commerçant souhaitant améliorer son service client sans embaucher.', en: 'An e-retailer wanting to improve customer service without hiring.' },
        action: { fr: 'Chatbot IA entraîné sur la FAQ et l\'historique des tickets, hébergé en Europe.', en: 'AI chatbot trained on FAQ and ticket history, hosted in Europe.' },
        result: { fr: '60% des demandes résolues automatiquement, CSAT en hausse de 15 points.', en: '60% of requests resolved automatically, CSAT up 15 points.' },
      },
    ],
    cta: { fr: 'Explorer les possibilités IA', en: 'Explore AI possibilities' },
    proofPartners: ['Solutions souveraines', 'Hébergement européen', 'RGPD compliant'],
    externalLink: null,
    externalLabel: null,
  },
  'formation': {
    icon: 'GraduationCap',
    image: 'https://images.unsplash.com/photo-1758691736508-a85d1f7d5a77?w=1200',
    promise: {
      fr: 'Des équipes formées, une entreprise plus performante.',
      en: 'Trained teams, a more efficient company.',
    },
    benefits: [
      { fr: 'Formations certifiées Qualiopi', en: 'Qualiopi-certified training' },
      { fr: 'Ateliers IA pratiques pour vos équipes', en: 'Hands-on AI workshops for your teams' },
      { fr: 'Programmes adaptés à votre niveau et vos outils', en: 'Programs tailored to your level and tools' },
      { fr: 'Formateurs experts et praticiens', en: 'Expert and practitioner trainers' },
      { fr: 'Financement OPCO possible', en: 'OPCO funding possible' },
    ],
    useCases: [
      {
        situation: { fr: 'Une équipe commerciale peu à l\'aise avec les outils Microsoft 365.', en: 'A sales team uncomfortable with Microsoft 365 tools.' },
        action: { fr: 'Programme de 3 jours sur Teams, SharePoint et Power BI.', en: '3-day program on Teams, SharePoint and Power BI.' },
        result: { fr: 'Adoption des outils en hausse de 70%, collaboration inter-équipes facilitée.', en: 'Tool adoption up 70%, cross-team collaboration facilitated.' },
      },
      {
        situation: { fr: 'Un service comptable ciblé par des tentatives de phishing répétées.', en: 'An accounting department targeted by repeated phishing attempts.' },
        action: { fr: 'Formation cybersécurité + campagne de phishing simulée.', en: 'Cybersecurity training + simulated phishing campaign.' },
        result: { fr: 'Taux de clic sur phishing passé de 35% à 4%.', en: 'Phishing click rate dropped from 35% to 4%.' },
      },
      {
        situation: { fr: 'Une direction souhaitant comprendre les enjeux de l\'IA pour son secteur.', en: 'A management team wanting to understand AI challenges for their industry.' },
        action: { fr: 'Atelier IA d\'une journée : concepts, cas d\'usage concrets, outils testés.', en: 'One-day AI workshop: concepts, concrete use cases, tools tested.' },
        result: { fr: '3 projets IA identifiés et priorisés à l\'issue de l\'atelier.', en: '3 AI projects identified and prioritized by end of workshop.' },
      },
    ],
    cta: { fr: 'Découvrir les formations', en: 'Discover training programs' },
    proofPartners: ['Qualiopi', 'MCF Formation', 'OPCO'],
    externalLink: 'https://mcf-formation.fr',
    externalLabel: { fr: 'Voir le catalogue MCF Formation', en: 'View MCF Training catalog' },
  },
};

export default solutions;
